export default {
  online_shop: 'Online winkel',
  storefront: 'Winkelfront',
  reservations: 'Reserveringen',
  import: 'Import',
};
